interface Props {
  onAnalysisClick: () => void;
}

export default function CtaSection({ onAnalysisClick }: Props) {
  return (
    <section id="cta-section" aria-labelledby="cta-heading">
      <div className="cta-glow" aria-hidden="true" />
      <div className="cta-orb"  aria-hidden="true" />
      <div className="container cta-inner">
        <span className="section-tag fade-up" style={{ marginBottom: 20 }}>Poďme na to</span>
        <h2 id="cta-heading" className="cta-h2 fade-up delay-1">
          Váš web si zaslúži<br /><span className="grad">lepší výsledok.</span>
        </h2>
        <p className="cta-sub fade-up delay-2">
          Napíšte nám. Do <strong>24 hodín</strong> dostanete bezplatnú analýzu vášho webu
          a konkrétne odporúčania – bez záväzku.
        </p>
        <div className="cta-btn-row fade-up delay-3">
          <button
            className="btn-primary"
            style={{ fontSize: '1.05rem', padding: '16px 36px' }}
            onClick={onAnalysisClick}
          >
            Chcem bezplatnú analýzu →
          </button>
          <a
            href="mailto:info@boostio.sk"
            className="btn-secondary"
            style={{ fontSize: '1.05rem', padding: '16px 36px' }}
          >
            Napíšte nám
          </a>
        </div>
        <p className="cta-note fade-up delay-4">Bez záväzku · Odpoveď do 24 hodín · 100% zadarmo</p>
      </div>
    </section>
  );
}
